import React from 'react'
import { LayoutBand, Separator } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import { PersonBandSkeleton } from '@fs/zion-person-band'
import NotesCardSkeleton from '../person-page/cards/notes-card/NotesCardSkeleton'
import DiscussionsCardSkeleton from '../person-page/cards/discussions-card/DiscussionsCardSkeleton'

export default function NotesPageSkeleton(): JSX.Element {
  const hideDiscussions = useFeatureFlag('treeWebTx_personR9_hideDiscussions').isOn
  return (
    <>
      <PersonBandSkeleton maxWidth="lg" marginX="xxs" hasBackButton disableColoredBackground />

      <LayoutBand maxWidth="lg" marginY="sm">
        <NotesCardSkeleton />
        {!hideDiscussions && (
          <>
            <Separator size="sm" />
            <DiscussionsCardSkeleton />
          </>
        )}
      </LayoutBand>
    </>
  )
}
